import { Injectable } from '@angular/core';
import { UserCacheService } from 'src/app/common/services/user-cache.service';
import { ApiNameList } from '../../../../../environments/api-name-list';
import { HttpClientService } from '../../../../common/services/http-client-service';

@Injectable()
export class AddDependentAccountService {
    public baseUrl = '';
    constructor(public httpClientService: HttpClientService, private userCacheService: UserCacheService) {
        this.baseUrl = ApiNameList.restApi.baseUrl;
    }

    planStatus(participationId: string, enrollmentId: string, addDepQLE?: boolean): any {
        const requestObject = {
            participationId,
            enrollmentId,
            addDepQLE
        };
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.planStatus, requestObject);
    }
    submitDepEnrollment(request: any): any {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.submitDepEnrollment, request);
    }
}
